// extracted by mini-css-extract-plugin
export default {"searchButton":"searchButton__SearchButton__WkReY","searchIconWrapper":"searchIconWrapper__SearchButton__WkReY","searchIcon":"searchIcon__SearchButton__WkReY"};